export default () => {

    const footer = document.querySelector('.footer');
    const spacer = document.querySelector('.footer-spacer');

    const adjust = () => {
        const rect = footer.getBoundingClientRect();
        spacer.style.height = rect.height + 'px';
    }

    window.addEventListener('resize', () => {
        adjust();
    });

    adjust();

}
